import { useNavigate } from 'react-router-dom';
import { ChevronLeft, ChevronRight, CheckCircle2, Circle } from 'lucide-react';
import type { FC } from 'react';

interface LessonNavigationProps {
  courseSlug: string;
  prevSlug: string | null;
  nextSlug: string | null;
  isCompleted: boolean;
  onToggleComplete: () => void;
}

export const LessonNavigation: FC<LessonNavigationProps> = ({
  courseSlug, prevSlug, nextSlug, isCompleted, onToggleComplete,
}) => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-between gap-3 pt-6 border-t border-slate-200 dark:border-slate-700">
      {/* Previous */}
      {prevSlug ? (
        <button
          onClick={() => navigate(`/learning/${courseSlug}/${prevSlug}`)}
          className="flex items-center gap-1.5 rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 px-3 py-2 text-sm font-medium text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors"
        >
          <ChevronLeft className="w-4 h-4" />
          Precedent
        </button>
      ) : <div />}

      {/* Toggle complete */}
      <button
        onClick={onToggleComplete}
        className={`flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-medium transition-all duration-200 ${
          isCompleted
            ? 'border border-emerald-200 dark:border-emerald-800 bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-300 hover:bg-emerald-100 dark:hover:bg-emerald-900/50'
            : 'bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 dark:hover:bg-blue-600 shadow-sm'
        }`}
      >
        {isCompleted ? (
          <><CheckCircle2 className="w-4 h-4" /> Lu</>
        ) : (
          <><Circle className="w-4 h-4" /> Marquer comme lu</>
        )}
      </button>

      {/* Next */}
      {nextSlug ? (
        <button
          onClick={() => navigate(`/learning/${courseSlug}/${nextSlug}`)}
          className="flex items-center gap-1.5 rounded-lg bg-blue-600 dark:bg-blue-500 px-3 py-2 text-sm font-medium text-white hover:bg-blue-700 dark:hover:bg-blue-600 shadow-sm transition-colors"
        >
          Suivant
          <ChevronRight className="w-4 h-4" />
        </button>
      ) : <div />}
    </div>
  );
};
